import { useState } from 'react';
import { useFollowingsQuery } from '../../../components/api/queries/FollowUserProfiles';
import MyPageMenuList from './MyPageMenuList';
import ProfileAvatarSection from './ProfileAvatarSection';
import ProfileNickname from './ProfileNickname';
import RoundedCard from './RoundedCard';
import UpdateUserProfileBottomSheet from './UpdateUserProfileBottomSheet';
import type { UserDataType } from '../../types/UserType';
import SmallArrowRightIcon from '../my-page-test-icon/SmallArrowRightIcon';
import AddUserProfileV1BottomSheet from '../../../components/bottomSheet/AddUserProfileV1BottomSheet';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

interface SocialProfileCardProps {
  user: UserDataType;
}

const SocialProfileCard = ({ user }: SocialProfileCardProps) => {
  const socialProfileMenu = [
    {
      title: 'myPage.myPageMenuItem.manageCollectedPhotoCards',
      path: '/collections'
    },
    {
      title: 'myPage.myPageMenuItem.manageReportedPhotoCards',
      path: '/reported-photo-cards'
    },
    {
      title: 'myPage.myPageMenuItem.manageWishedPhotoCards',
      path: `/users/${user.userId}/my_photo_cards_wish`
    },
    {
      title: 'myPage.myPageMenuItem.manageWishedPlace',
      path: '/locations/like'
    }
  ];
  const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
  const navigate = useNavigate();
  const { data: followingsData } = useFollowingsQuery(user.baseUserProfile?.userProfileId, 1);

  const followingsCount = followingsData?.pages?.[0]?.meta?.pagination?.totalCount || 0;

  const handleEditNickname = () => {
    setIsShowBottomSheet(true);
  };

  const handleNavigateToProfile = () => {
    if (user.baseUserProfile) {
      navigate(`/feed/user_profile/${user.baseUserProfile?.userProfileId}`);
    } else {
      setIsShowBottomSheet(true);
    }
  };

  return (
    <>
      <RoundedCard>
        <div className="px-[20px] pb-[12px]">
          <div className="flex pt-[20px] pb-[6px] gap-[12px] items-center">
            <ProfileAvatarSection
              thumbnailUrl={user.baseUserProfile?.thumbnailUrl}
              userProfileId={user.baseUserProfile?.userProfileId}
              nickname={user.baseUserProfile?.nickname}
              description={user.baseUserProfile?.description}
              onCreateProfile={() => setIsShowBottomSheet(true)}
            />
            <div className="flex justify-between w-full items-center">
              <div className="flex flex-col gap-[8px]">
                <ProfileNickname
                  nickname={user.baseUserProfile?.nickname}
                  onEditClick={handleEditNickname}
                />
                <div className="flex gap-[9px] text-[11px] text-main-light-2 dark:text-main-dark-2 leading-none">
                  <p>
                    Following <strong>{followingsCount}</strong>
                  </p>
                  <p>
                    Follower <strong>{user.baseUserProfile?.followersCount || 0}</strong>
                  </p>
                </div>
              </div>
              <div>
                <button type="button" onClick={handleNavigateToProfile}>
                  <SmallArrowRightIcon className="fill-main-light-3 dark:fill-main-dark-3 w-[16px] h-[16px]" />
                </button>
              </div>
            </div>
          </div>
          <MyPageMenuList items={socialProfileMenu} />
        </div>
      </RoundedCard>

      {user.baseUserProfile ? (
        <UpdateUserProfileBottomSheet
          title="socialProfileNicknameChangeTitle"
          userProfile={user.baseUserProfile}
          isShowProfileBottomSheet={isShowBottomSheet}
          setIsShowProfileBottomSheet={setIsShowBottomSheet}
        />
      ) : (
        <AddUserProfileV1BottomSheet
          title={t('createFeedUserProfilePage.title')}
          category="base"
          userProfile={user.baseUserProfile}
          isShowProfileBottomSheet={isShowBottomSheet}
          setIsShowProfileBottomSheet={setIsShowBottomSheet}
          onCompleted={() => {}}
        />
      )}
    </>
  );
};

export default SocialProfileCard;
